import HoverCard from "../HoverCard";
import AnimatedNumber from "../AnimatedNumber";
import formatMoney from "../../formatMoney";

function Card({ id, name, balance, logo, editable, onEdit }) {
  return (
    <div className="col-12 col-md-6 col-lg-4">
      <HoverCard className="bg-white rounded-3 shadow-sm border-0 transition-all">
        <div className="p-3">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="d-flex align-items-center gap-3">
              <div className="bg-primary bg-opacity-10 text-primary rounded-3 p-2 d-flex align-items-center justify-content-center">
                <i className="bi bi-bank fs-5" />
              </div>

              <div className="d-flex flex-column">
                <span className="fw-semibold text-dark">{name}</span>
                <small className="text-muted">Account</small>
              </div>
            </div>

            {logo && (
              <div
                className="bg-primary bg-opacity-10 p-1 rounded-3 d-flex align-items-center justify-content-center"
                style={{ width: 44, height: 44 }}
              >
                <img
                  src={logo}
                  alt="Logo"
                  className="img-fluid"
                  style={{
                    maxWidth: "80%",
                    maxHeight: "80%",
                    objectFit: "contain",
                  }}
                />
              </div>
            )}
          </div>

          <div className="pt-2 border-top">
            <small className="text-muted">Current Balance</small>
            <div className="fs-5 fw-bold text-primary">
              &#8369; <AnimatedNumber value={balance} formatter={formatMoney} />
            </div>
          </div>
        </div>

        {editable && (
          <div className="d-flex justify-content-end gap-2">
            <button
              className="btn bg-primary fw-medium text-white px-3"
              onClick={() => onEdit(id)}
            >
              <i className="bi bi-pencil me-2"></i>
              Edit
            </button>
          </div>
        )}
      </HoverCard>
    </div>
  );
}

export default Card;
